import { jsx as _jsx } from "react/jsx-runtime";
import { PlayerControlLabelButton } from "./PlayerControlLabelButton";
// eslint-disable-next-line @typescript-eslint/no-empty-function -- noop function used to prevent onClick when disabled
const noop = () => { };
export const CustomButton = ({ onClick, text, ariaLabel, Icon, disabled, }) => {
    return (_jsx(PlayerControlLabelButton, { "aria-disabled": disabled, disabled: disabled, "aria-label": ariaLabel, onClick: disabled ? noop : onClick, Icon: Icon, label: text, hoverText: text }));
};
